<template>
  <div>
    <div class="label-project">{{ label }}</div>
    <div class="parent-input">
      <input
        autocomplete="off"
        :class="disabled === 'true' ? 'input-disable' : ''"
        :disabled="disabled"
        :style="cssVars"
        @input="handleInput"
        :value="value"
        :id="!visible ? 'input-project' : 'input-project-show'"
        :type="!eye ? type : 'text'"
        :placeholder="placeholder"
      />
      <div v-if="visible" @click="hideEye">
        <svg-icon v-show="!eye" class="icon-input" icon="eyeup" />
      </div>
      <div v-if="visible" @click="hideEye">
        <svg-icon v-show="eye" class="icon-input" icon="eyedown" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    eye: false,
  }),
  props: {
    disabled: String,
    label: String,
    value: [String , Number],
    width: String,
    placeholder: String,
    type: String,
    visible: Boolean,
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e.target.value);
    },
    hideEye() {
      this.eye = !this.eye;
    },
  },
  computed: {
    cssVars() {
      return { "--width": this.width + "%" };
    },
  },
};
</script>

<style lang="scss" scoped>
.parent-input {
  position: relative;
}

.icon-input {
  position: absolute;
  font-size: 30px;
  right: 10px;
  top: 5px;
  cursor: pointer;
  color: #666;
}

.icon-input:hover {
  color: #000;
}

.label-project {
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 600;
}
.input-disable {
  background-color: #e9ecef;
  cursor: not-allowed;
}

#input-project {
  width: var(--width);
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  height: 40px;
  padding: 5px 15px;
  font-size: 14px;
  outline: none;
  margin-bottom: 11.2px;
  color: #666;
}

#input-project-show {
  width: var(--width);
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  height: 40px;
  padding: 5px 12px;
  padding-right: 47px;
  font-size: 14px;
  outline: none;
  margin-bottom: 11.2px;
  color: #666;
}

#input-project:focus,
#input-project-show:focus {
  border-color: #2a44db;
  color: #8898aa;
}

::placeholder {
  color: #adb5bd;
  opacity: 1;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>